export default __webpack_public_path__ + "static/media/shortly.3c01b577.svg";